module.exports = __webpack_public_path__ + "static/media/just-tech-news.a56e442c.png";